import { Mail, Phone, Clock } from "lucide-react";
import SEO from "@/components/site/SEO";
import PageHeader from "@/components/site/PageHeader";
import JobberWorkRequestForm from "@/components/site/JobberWorkRequestForm";
import { SITE } from "@/lib/site";

export default function Quote() {
  return (
    <div data-testid="quote-page">
      <SEO
        title="Free Parking Lot Quote — Memphis & Mid-South"
        description="Request a free fixed-price quote for parking lot striping, sealcoating, ADA compliance, or pavement marking. We respond within 48 hours across the Mid-South."
        path="/quote"
      />
      <PageHeader
        eyebrow="Free quote"
        title="Tell us about your project."
        subtitle="Fill out the work-request form. We'll come out, walk the property, and email you a fixed-price quote within 48 hours."
      />

      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8">
            <JobberWorkRequestForm />
          </div>

          <aside className="lg:col-span-4">
            <div className="bg-slate-900 text-white rounded-lg p-7">
              <h3 className="font-display font-bold text-xl">Prefer to talk?</h3>
              <p className="mt-2 text-sm text-slate-300 leading-relaxed">
                Reach us directly any business day. We typically reply
                within a few hours.
              </p>
              <div className="mt-6 space-y-4 text-sm">
                <a
                  href={SITE.phoneHref}
                  data-testid="quote-aside-phone"
                  className="flex items-center gap-3 hover:text-orange-300"
                >
                  <Phone className="h-5 w-5 text-orange-400" />
                  {SITE.phone}
                </a>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="quote-aside-email"
                  className="flex items-center gap-3 hover:text-orange-300"
                >
                  <Mail className="h-5 w-5 text-orange-400" />
                  {SITE.email}
                </a>
                <div className="flex items-center gap-3 text-slate-300">
                  <Clock className="h-5 w-5 text-orange-400" />
                  Mon–Sat · 7 AM – 7 PM
                </div>
              </div>
            </div>

            <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h4 className="font-display font-semibold text-slate-900">
                What happens next
              </h4>
              <ol className="mt-3 space-y-2 text-sm text-slate-700 list-decimal list-inside">
                <li>We confirm receipt of your request.</li>
                <li>A 15-minute call to align on scope.</li>
                <li>Free on-site walk + written quote.</li>
              </ol>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
